import {
    EquityOrderLeg,
    OptionOrderLeg,
    Order,
    OrderLeg,
    OrderSide,
    PlaceOrderRequest,
    SingleOrder,
    TfOrder,
    TmcOrder
} from "../models/Order";
import {Optional} from "../../js/util/Optional";
import {formatDate} from "../../js/util/DateTimeUtil";

/** @deprecated */
export class OrderUtil {

    public static formatExpiry(expiry: string): string {
        return formatDate(expiry, "MMM YY");
    }

    public static formatStrike(order: SingleOrder | OptionOrderLeg | null): string {
        if (order == null || order.strike == null) {
            return "";
        }
        const underlying = order.code.substring(0, 3);
        if (underlying === "XJO") {
            return order.strike.toFixed(0);
        } else {
            return order.strike.toFixed(3);
        }
    }

    public static side(order: any): string {
        if (OrderUtil.hasSide(order)) {
            return order.side;
        } else if (OrderUtil.hasBuy(order)) {
            return order.buy ? OrderSide.BUY : OrderSide.SELL;
        } else {
            return order.quantity > 0 ? OrderSide.BUY : OrderSide.SELL;
        }
    }

    public static legSide(leg: OrderLeg): string {
        return Optional.of(leg.side)
                       .orElseGet(() => leg.ratio > 0 ? OrderSide.BUY : OrderSide.SELL);
    }

    public static isOrderRequest(order: Order): order is PlaceOrderRequest {
        return !OrderUtil.isTfOrder(order);
    }

    public static isTmc(order: Order): order is TmcOrder {
        return OrderUtil.isTfOrder(order) && order.tmc;
    }

    public static isTfOrder(order: Order): order is TfOrder {
        return "id" in order;
    }

    public static hasSide(order: Order): order is Order & {side: OrderSide} {
        return "side" in order;
    }

    public static hasBuy(order: Order): order is Order & {buy: boolean} {
        return "buy" in order;
    }

    public static isEquityLeg(leg: OrderLeg): leg is EquityOrderLeg {
        return leg.legType === "E";
    }

    public static isOptionLeg(leg: OrderLeg): leg is OptionOrderLeg {
        return leg.legType === "O";
    }
}
